import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Card, Space } from "antd";
import { storage } from "../../firebase";
import { FilePdfOutlined, PlayCircleOutlined } from "@ant-design/icons";
import { Viewer, Worker, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { toolbarPlugin } from "@react-pdf-viewer/toolbar";
import "@react-pdf-viewer/core/lib/styles/index.css";
import Title from "antd/es/typography/Title";

const VerCapacitacion = ({ documento }) => {
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState("");
  const toolbarPluginInstance = toolbarPlugin();
  const { Toolbar } = toolbarPluginInstance;
  const videoRef = useRef(null);
  const viewerRef = useRef(null);

  const handleOpen = () => {
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  const handleModalClose = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    handleClose();
  };

  const getFile = async (path) => {
    try {
      const storageRef = storage.ref();
      const fileRef = storageRef.child(`/capacitaciones/${path}`);
      const url = await fileRef.getDownloadURL();
      setUrl(url);
    } catch (error) {
      console.error("Error al obtener el archivo:", error);
    }
  };

  const disableRightClick = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    getFile(documento.documento);
  }, [documento]);

  return (
    <>
      <Card
        hoverable
        cover={
          documento.documento.includes(".mp4") ? (
            <video
              controls
              volume="1.0"
              controlsList="nodownload"
              onContextMenu={disableRightClick}
              style={{ width: "100%", height: "100px", objectFit: "cover" }}
            >
              <source src={url} type="video/mp4" />
            </video>
          ) : (
            <div
              style={{
                height: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FilePdfOutlined style={{ fontSize: "48px", color: "#d32f2f" }} />
            </div>
          )
        }
      >
        <Card.Meta
          title={documento.nombre}
          description={`Versión: ${documento.version}`}
        />
        <div style={{ marginTop: "10px", textAlign: "center" }}>
          <Button
            type="primary"
            icon={
              documento.documento.includes(".pdf") ? (
                <FilePdfOutlined />
              ) : (
                <PlayCircleOutlined />
              )
            }
            onClick={handleOpen}
          >
            {documento.documento.includes(".pdf")
              ? "Ver Documento"
              : "Reproducir Video"}
          </Button>
        </div>
      </Card>

      <Modal
        visible={visible}
        title={documento.nombre}
        footer={null}
        onCancel={handleModalClose}
        width={documento.documento.includes(".pdf") ? "90%" : "80%"}
        style={{ top: 20 }}
  bodyStyle={{ padding: 0 }}
      >
        {documento.documento.includes(".pdf") ? (
          <div style={{ height: "calc(90vh - 100px)", maxHeight: "80vh", overflowY: "auto", overflowX: "hidden" }}>
            <Title level={3} className="ccg-center">
              Visualizador de Documentos
            </Title>
            <Space>
              <Toolbar>
                {(props) => {
                  const { ZoomIn, ZoomOut } = props;

                  return (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <Button icon={<ZoomOut />} onClick={ZoomOut}>
                        Zoom -
                      </Button>
                      <Button icon={<ZoomIn />} onClick={ZoomIn}>
                        Zoom +
                      </Button>
                    </div>
                  );
                }}
              </Toolbar>
            </Space>
            <div
              style={{ position: "relative", height: "100%", minHeight: 600, overflow: "visible", userSelect: "none", WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none" }}
              ref={viewerRef}
              onCopy={e => e.preventDefault()}
              onCut={e => e.preventDefault()}
              onPaste={e => e.preventDefault()}
              onSelectStart={e => e.preventDefault()}
              onMouseDown={e => e.preventDefault()}
            >
              {/* Marca de agua visual */}
              <div
                className="ccg-footer-container"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  pointerEvents: "none",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                  opacity: 0.22,
                  fontSize: "8vw",
                  color: "#283891",
                  transform: "rotate(-25deg)",
                  userSelect: "none",
                  whiteSpace: "pre-line",
                  textAlign: "center",
                  textShadow: "2px 2px 8px #fff, 0 0 2px #283891",
                  lineHeight: 1.15
                }}
              >
                CONTROL DE CALIDAD<br />Y GEOTÉCNIA S.A DE C.V
              </div>
              <Worker
                workerUrl={
                  "https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js"
                }
              >
                <Viewer
                  fileUrl={url}
                  plugins={[toolbarPluginInstance]}
                  initialZoom={SpecialZoomLevel.PAGE_WIDTH}
                />
              </Worker>
            </div>
          </div>
        ) : (
          <video
            ref={videoRef}
            width="100%"
            style={{ maxHeight: "70vh" }}
            src={url}
            title={documento.nombre}
            controls
            volume="0"
            controlsList="nodownload"
            onContextMenu={disableRightClick}
            autoPlay
          />
        )}
      </Modal>
    </>
  );
};

export default VerCapacitacion;